
export default {
	setMemberInfo : (state,MemberData) => {
		/** 가입자 정보페이지 */
		state.MemberInfoData.name = MemberData.name;
		state.MemberInfoData.mobile = MemberData.mobile;
		state.MemberInfoData.birth = MemberData.birth;
		state.MemberInfoData.gender = MemberData.gender;
	},
	setJoinUrl: (state,url) =>{
		state.joinUrl = url;
	},
	setGradeCode: (state,grade_code) =>{
		state.grade_code = grade_code;
	},
	setCurrentPage: (state,currentPage) =>{
		state.currentPage = currentPage;
	},
	setIsEncrypted: (state,isEncrypted) =>{
		state.isEncrypted = isEncrypted;
	},
	setPasscode: (state,seq) =>{
		state.pass_code = seq;
	},
	setUserSeq: (state,seq) =>{
		state.user_seq = seq;
	},
	setTestEvn: (state,value) =>{
		state.test_env = value;
	},
	setLoginInfo: (state,LoginInfo) => {
		/* 로그인 정보 페이지 */
		state.login_info.id = LoginInfo.id;
		state.login_info.pass = LoginInfo.pass;
		state.login_info.seq = LoginInfo.seq;
	},
	setAccessToken:(state,token) => {
		/* 로그인 정보 페이지 */
		state.socialLogin.accessToken = token;
	},
	setSocialId:(state,token) => {
		/* 로그인 정보 페이지 */
		state.socialLogin.id = token;
	},
	setSocialCorpName:(state,newCorpName) => {
		// 허용된 소셜 로그인 업체 목록
		const allowedCorpNames = ["kakao", "naver"];

		if (!allowedCorpNames.includes(newCorpName)) {
			throw new Error("소셜 로그인 인증 업체가 잘못 지정되었습니다.");
		}

		// 로그인 정보 페이지
		state.socialLogin.corpName = newCorpName;
	},
	changeIsSocialLogin:(state,token) => {
		/* 로그인 정보 페이지 */
		state.isSocialLogin = token;
	},
	resetSocialLoginInfo:(state) => {
		/* 로그인 정보 페이지 */
		state.isSocialLogin= false;
		state.socialLogin.accessToken = '';
		state.socialLogin.id = -1;
		state.socialLogin.corpName = '';
	},
	savePages:(state,pages) => {
		/* 로그인 정보 페이지 */
		state.pages = pages;
	},
};
